const REGION_PREFIX = /^(AU|CA|US)_/;

type UserWithCountry = {
  id?: string | null;
  customer?: { country?: string | null } | null;
};

/**
 * Country for analytics: the account's country, or the region prefix of the user id
 * (AU_, CA_, US_) when the account country is missing. Every main-platform user id
 * carries that prefix, so a profile is never written with an empty country.
 */
export function getUserCountry(user?: UserWithCountry | null): string | undefined {
  const accountCountry = user?.customer?.country;
  if (accountCountry) return accountCountry;
  const match = (user?.id ?? '').match(REGION_PREFIX);
  return match ? match[1] : undefined;
}
